export default __webpack_public_path__ + "img/112ef27005a4bd652dfbdba339a7a69b.svg";